import { combineReducers, createStore } from 'redux'
import * as reducers from 'store/reducer'

const combinedReducers = combineReducers(reducers)

export default createStore(combinedReducers)
